import { initReactI18next } from 'react-i18next';
import i18n from 'i18next';
const supportedLanguages = ['en', 'fr', 'de'];
const pickInitialLanguage = () => {
    const browserLanguages = navigator.languages?.length ? navigator.languages : [navigator.language];
    for (const lang of browserLanguages) {
        const base = lang.split('-')[0];
        if (supportedLanguages.includes(base)) {
            return base;
        }
    }
    return 'en';
};
const i18nConfig = {
    lng: pickInitialLanguage(),
    fallbackLng: 'en',
    debug: process.env.NODE_ENV === 'development',
    supportedLngs: supportedLanguages,
    load: 'languageOnly',
    interpolation: {
        escapeValue: false,
    },
};
i18n.use(initReactI18next).init(i18nConfig);
